import { render, staticRenderFns } from "./setType2Template.vue?vue&type=template&id=750c78b4&scoped=true"
import script from "./setType2Template.vue?vue&type=script&lang=js"
export * from "./setType2Template.vue?vue&type=script&lang=js"
import style0 from "./setType2Template.vue?vue&type=style&index=0&id=750c78b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750c78b4",
  null
  
)

export default component.exports